import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

import CloudinaryImage from '../../../../cloudinary-media/image'

const Banner = ({desktopImage, mobileImage, imageAlt, variant}) => {
    const mobileSrc = mobileImage || desktopImage

    const sizeDesktop = {
        width: variant === 'promoGridTwoItems' ? 955 : 472,
        height: variant === 'promoGridTwoItems' ? 540 : 428
    }
    const sizeMobile = {
        width: variant === 'promoGridTwoItems' ? 414 : 364,
        height: variant === 'promoGridTwoItems' ? 336 : 386
    }

    return (
        <>
            <Box display={{base: 'none', md: 'block'}} height="100%">
                <CloudinaryImage
                    src={desktopImage}
                    aspectRatio={`${sizeDesktop.width}:${sizeDesktop.height}`}
                    imgSizes={{base: variant === 'promoGridTwoItems' ? '50vw' : '25vw'}}
                    lazyload={false}
                    sizes={[320, 640, 1024, 1440]}
                    alt={imageAlt}
                    styles={{
                        aspectRatio: `${sizeDesktop.width} / ${sizeDesktop.height}`,
                        width: '100%',
                        fetchpriority: 'high',
                        loading: 'eager',
                        height: '100%',
                        objectFit: 'cover',
                        htmlWidth: sizeDesktop.width,
                        htmlHeight: sizeDesktop.height
                    }}
                />
            </Box>

            <Box display={{base: 'block', md: 'none'}} height="100%">
                <CloudinaryImage
                    src={mobileSrc}
                    aspectRatio={`${sizeMobile.width}:${sizeMobile.height}`}
                    imgSizes={{base: '100vw'}}
                    lazyload={false}
                    sizes={[375, 390, 414, 640]}
                    alt={imageAlt}
                    styles={{
                        aspectRatio: `${sizeMobile.width} / ${sizeMobile.height}`,
                        width: '100%',
                        fetchpriority: 'high',
                        loading: 'eager',
                        height: '100%',
                        objectFit: 'cover',
                        htmlWidth: sizeMobile.width,
                        htmlHeight: sizeMobile.height
                    }}
                />
            </Box>
        </>
    )
}

Banner.propTypes = {
    desktopImage: PropTypes.string.isRequired,
    mobileImage: PropTypes.string,
    imageAlt: PropTypes.string,
    variant: PropTypes.string,
    mediaSize: PropTypes.string,
    desktopMediaPosition: PropTypes.string,
    mobileMediaPosition: PropTypes.string
}

export default Banner
